﻿import { DrawingService } from './DrawingService.js';

/**
 * The HtmlDrawingService implements the interface referenced by the Component/Product classes for
 * updating the drawing (in this case a html/css based 2D drawing).
 */
export class DrawingService2020 extends DrawingService {
  constructor(productDrawing, loadedMaterials, getProductFinishName, onLoadSingleMaterial) {
    super(getProductFinishName);
    // The html div element hosting the drawing:
    this.productDrawing = productDrawing;
    this.isDrawingUpdatesEnabled = true;
    // An object whose properties are finish id's and values are ProductMaterialsMap objects (items of the ProductMaterialsMap)
    this.materials = {};
    this.loadedMaterials = loadedMaterials;
    // This event is raised when we replace a component's finish, if the component's material has not yet been loaded:
    this.onLoadSingleMaterial = onLoadSingleMaterial;
  }

  /**
   * When disabled any user call to update the drawing should be ignored.
   */
  disableDrawingUpdates() {
    this.isDrawingUpdatesEnabled = false;
  }

  enableDrawingUpdates() {
    this.isDrawingUpdatesEnabled = true;
    return true;
  }

  //#region Material Methods

  /**
   * This method is normally called from the ProductDrawing class' constructor and updates
   * the this.materials object with properties (material id's) from the materialImages parameter.
   * materialImages typically is the ProductMaterialsMap which is based on the json file with
   * the same name. The value of each material id property is a reference to items of the materialImages.
   *
   * The ProductDrawing class also has a loadMaterials method which delegates to
   * HtmlDrawingEngine.loadMaterials using this.materials and a list of material id's to be loaded
   * as input. That method is the one which downloads the image resources from the server.
   *
   * This class also has a getMaterial method which is used by individual Component/Product objects
   * to get and assign their material property. The getMaterial method returns one of the
   * objects from this.materials.
   */
  addMaterials(materialImages, cmScale) {
    materialImages.forEach(matr => this.materials[matr.id] = matr);
  }

  addFallbackMaterials() {
  }

  getMaterial(materialIdPrefix, finishId, delimiter = this.materialPrefixDelim) {
    const materialId = materialIdPrefix + delimiter + finishId;
    let material = this.materials[materialId];
    if (typeof material === 'undefined') {
      // Try using just the finish
      //console.log(`Unknown prefix/finish combination: prefix=${materialIdPrefix}, finish=${finishId}. Trying fallback using just the finish`);
      material = this.materials[finishId];
    }
    if (typeof material === 'undefined') {
      throw new Error(`Unknown prefix/finish combination: prefix=${materialIdPrefix}, finish=${finishId}. ` +
        `If this is a valid combination, then ensure it's listed in the ProductMaterialsMap.js.`);
    }
    return material;
  }

  // /**
  //  * Used by the ProductDrawing class to add materials.
  //  */
  // addMaterial(material) {
  //   this.materials[material.id] = material;
  // }

  /*
   * Tries to replace the finish/material on the displayObject and returns true if successful.
   * If it's not possible to replace the finish on the existing display object (a different
   * display object must be created), then return false. For Pixi, this method returns true if
   * the old and new materials are of the same type (ColorMaterial versus ResourceMaterial).
   * If the material is drawn with a PIXI.Graphics object, then the object's graphics will be
   * redrawn using the new finish (i.e. color). If a PIXI.Sprite, the sprite's texture will be
   * replaced with a new one containing an image representing the finish.
   */
  replaceFinishInline(component, newFinish) {
    // We must call setFinish specifically here because the visitor requires the component's material
    // to be updated. Since we're doing this manually, we're also preventing notification and instead
    // call the finishChanged notification method manually at the end.
    if (component.setFinish(newFinish, /*preventNotification:*/ true)) {
      this.updateAllFinishesInline(component);
      component.finishChanged();
    }
    return true;
  }

  /**
   * If we have a single material loader callback available, then let the visitor know about it.
   */
  assignMaterialJitLoaderTo(visitor) {
    if (this.onLoadSingleMaterial) {
      visitor.onJitLoadMaterial = async (material, onHisResImgLoaded) => {
        /* Will wait until the low-res material is loaded. The onHighResImgLoaded callback will
         * be called asynchronously after the high-res material has been loaded: */
        return await this.onLoadSingleMaterial(material, /*loadHighResAsWell:*/ true, onHisResImgLoaded);
      }
    }
  }

  updateAllFinishesInline(component) {
    this.performInlineUpdate(component, /*onInitVisitor:*/ visitor => {
      // 4/22/2021: The code below is now called from inside the performInlineUpdate method
      //  // If we have a single material loader callback available, then let the visitor know about it:
      //  if (this.onLoadSingleMaterial) {
      //    visitor.onJitLoadMaterial = async (material, onHisResImgLoaded) => {
      //      /* Will wait until the low-res material is loaded. The onHighResImgLoaded callback will
      //       * be called asynchronously after the high-res material has been loaded: */
      //      return await this.onLoadSingleMaterial(material, /*loadHighResAsWell:*/ true, onHisResImgLoaded);
      //    }
      //  }
    });
  }

  //#endregion Material Methods

}